import { subscription, updateBreadcrumb, getSubscriberLastInfos } from './Welcome';

export const updateSubscription = (prop, value) => {
  //  console.debug('Welcome.updateSubscription()', prop, '=', value);

    if (prop && subscription[prop] != value) {
        subscription[prop] = value;
        updateBreadcrumb();
        getSubscriberLastInfos();
    }
};
